import { BodyText, Tooltip } from "@/components/ui";
import { COPY_SAFE_UNDERLINE } from "../constants";
import type { PatientVitals as PatientVitalsReturn } from "../types/patientVitals";

interface PatientVitalsProps {
  vitals: PatientVitalsReturn | undefined;
}
export const Vitals = ({ vitals }: PatientVitalsProps) => {
  if (!vitals) return null;

  const { bmi, weight } = vitals || {};
  return (
    <BodyText tag="p" textColor="primary" size="sm">
      <Tooltip
        side="bottom"
        tooltipContentText={
          weight?.value !== undefined && weight?.unit
            ? `${weight?.value} ${weight?.unit}`
            : "No weight charted"
        }
      >
        <span className={COPY_SAFE_UNDERLINE}>
          BMI: {bmi?.value || "None charted"}
        </span>
      </Tooltip>
    </BodyText>
  );
};
